import axios from 'axios'
export default {
    namespaced: true,
    state: {
		name: 'VehicleBodystyle',
		endpoint: '/vehicle/bodystyle',
        items: [],
    },
    actions: {
		load (context, params) {
			return axios.get(`/vehicle/category/${params.category.id}/bodystyle`).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}